import { Controller } from "@hotwired/stimulus";

/**
 * お問い合わせページ (/contact)
 *
 * form data-controller="contact" data-action: "contact#submit"
 */
export default class extends Controller {
  /**
   * お問い合わせ送信時に車両IDをクッキーに保存
   */
  submit() {
    const q = new URLSearchParams(window.location.search);
    // マーケ側の集計仕様: 車両IDが取れなかった場合は0として記録
    const exhibited_car_id = q.get("contact[exhibited_car_id]") || 0;

    document.cookie = `transaction_exhibited_car_id=${exhibited_car_id}`;
  }
}
